import React, { Component } from "react";
import axios from "axios";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
// import { saveAs } from 'file-saver';
import Select from 'react-select';
import { currentDateAndTime,decodeData } from "../../Constants/constants";
import { NoRecords } from "../../Components/Shimmer";
import MainPageLoader from "../../Components/MainPageLoader";
import { SubmitButton } from "../../Components/InputElements";
class DocumentDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      errors: {},
      employee_id: "",
      employee_code: "",
      loadingList: false,
      postLoading: false,
      loadingUpload: false,
      loadingPost: false,
      documents: [],
      document_info: [],
      DownloadDocument: [],
      letters: [],
      salaries: [],
      documents_data: [],
      document_file:null,
      documentName:"",
      guest_employee_mobile_number:"",
      company_id:"",
      doc_title:"",
      doc_url:"",
      viewDocument:false,
      decodedData: [],
      docRows: [],
      selectedDocumentRows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
    };
  }

  componentDidMount() {
    const employee_id = this.props.params.employee_id;

    this.setState({ loadingList: true,
        employee_id: employee_id,
     }, (prevState) => {
      this.GetList();
      this.GetDocumentList();
    });
    
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
 
  GetDocumentList = () => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
  
      axios
        .get(`${apiURL}Employees/GetOtherDocumentsForEmployee`, {
          params: {
            employee_id: this.state.employee_id
          },
          headers,
        })
        .then((response) => {
          const data = response.data?.response;
          // console.log("GetOtherDocumentsForEmployee", data);
          if (response?.data?.success === true) {
            // const makeInt= data?.employee_document?.map((val)=>{
            //     return parseInt(val);
            // })
            console.log("data ", data);
            this.setState({ 
              docRows: data || [],
             },
            () => { console.log(this.state.docRows, this.state.selectedDocumentRows); }
            );
          } else {
            this.setState({ loadingList: false });
          }
        });
    };

  RemarkDocument = (employee_id, row) => {
    Swal.fire({
      title: "Submit Remark",
      input: "text",
      inputValue: row.document_remark,
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_id: employee_id,
          employee_document_id: row.employee_document_id,
          document_remark: result.value,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/RemarkDocument`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
              showConfirmButton: true,
          allowOutsideClick:false
            });
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  VerifyDocument = (row, type) => {
    console.log("row",row);
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type==="2"? "verify":"Unverify"} this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type==="2"? "verify":"Unverify"} it!`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
            employee_document_id: row?.employee_document_id,
            employee_id: this.state.employee_id,
        //   employee_document_status: type,
          date: currentDateAndTime(),
        };
        console.log(formData);
        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;
        let api= type==="2"? "Employees/VerifyDocument":"Employees/UnVerifyDocument";
        axios
          .post(`${apiURL}${api}`, formData, {
            headers,
          })
          .then((response) => {
            console.log("response", response);
            if (response?.data?.success === true) {
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
              this.setState({ loadingList: false }, () => {
                this.GetList();
                // this.props.callBack();
              });
            } else {
              this.setState({ loadingList: false }, () => {});
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };

  handleRowInputChange = (e, idx) => {
    const { value } = e.target; 
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
  

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_number: value,

    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_number: "",

    };
  
    this.setState({ documents_data: updatedDocumentsData, errors: updatedErrorData },()=>{ console.log(this.state.documents_data); }); 
  };

  handleFileChange = (e,idx) => {
    const file = e.target.files[0];
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_file: file, 
      document_number: this.state.documents_data[idx]?.document_number || this.state.rows[idx]?.employee_document_uid || "",
    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_file: "",

    };
  
    this.setState({
      document_file: file,
      documentName: file ? file.name : '',
      documents_data: updatedDocumentsData,
      errors: updatedErrorData ,
    },
      ()=>{ console.log(this.state.documents_data[idx]?.document_file?.name); });
  };

  removeFile = (idx) => {

    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_file: null,
      document_number:"", 
    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_file: "",
      document_number:"", 
    };
    this.setState({
      document_file: null,
      documentName:  '',
      documents_data: updatedDocumentsData,
      errors: updatedErrorData ,
    });
  };

  handleFileUpload = (row,idx ) => {
    console.log(this.state.documents_data);
    const errors = this.validateForm(idx);
    console.log(errors);
    if (errors[idx]?.document_file) {
      this.setState({ errors });
      return;
    }

    const fileData = this.state.documents_data[idx]?.document_file;
    const formData = {
        employee_document_id: row?.employee_document_id || null,
        date: currentDateAndTime(),
        employee_id: row?.employee_id,
        file: fileData,
        employee_document_uid: this.state.documents_data[idx]?.document_number,
      };

    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    this.setState({ loadingUpload:row?.employee_document_id })
    
    // `${apiURL}Employees/UploadEmployeeDocument`,
    // formData,
    // {
    //   headers:{
    //     Authorization: `${localStorage.getItem("token_erp")}`,
    //     token: localStorage.getItem("token_erp"),
    //     company_id: localStorage.getItem("company_id_erp"),
    //     user_id: localStorage.getItem("user_id_erp"),
    //     "Content-Type": "multipart/form-data",
    //   },
    // }
  
    // const headers = {
    //   Authorization: `${localStorage.getItem("token_erp")}`, 
    //   company_id: localStorage.getItem("company_id_erp"),
    //   user_id: localStorage.getItem("user_id_erp"),
    //   "Content-Type": "multipart/form-data",
    // };
    
    axios
      .post(`${apiURL}Employees/UploadEmployeeDocument`, formData, { headers })
      .then((response) => {
        const data = response.data;
        Swal.fire({
          title: `<strong>${data.success ? "Success" : "Failed"}</strong>`,
          text: data.message,
          icon: data.success ? "success" : "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
    
        this.setState({ loadingUpload: false }, () => {
          if (data.success) {
            this.GetList(row?.employee_document_id);
          }
        });
      })
      .catch((error) => {
        console.error("Error uploading file:", error.response?.data || error.message);
        Swal.fire({
          title: "<strong>Failed</strong>",
          text: error.response?.data?.message || "Oops...! Something went wrong!",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        this.setState({ loadingUpload: false });
      });
    
  };
  

  GetList = (id) => {
    const { apiHeaderJSON, apiURL } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(
        `${apiURL}Employees/GetProfile`,
        {
          params:{
            employee_id: this.state.employee_id,
            date: currentDateAndTime(),
          },
          headers }
      )
      .then((response) => {
        const data = response.data?.data;
        console.log("GetProfile",data);
        if (response.data?.success === true) {
         

          const newDocumentsArray = data?.documents?.length > 0 && data?.documents.map((val,idx) => ({
            employee_document_id: val?.employee_document_id,
            document_file: val?.employee_document_id == id? null : this.state.documents_data[idx]?.document_file || null,
            document_number: this.state.documents_data[idx]?.document_number || val?.employee_document_uid || "",
          }));
          const errorArray = data?.documents?.length > 0 && data?.documents.map((val,idx) => ({
            employee_document_id: val?.employee_document_id,
            document_file: this.state.errors[idx]?.document_file || "",
            document_number: this.state.errors[idx]?.document_number ||  "",
          }));
          this.setState({
            rows: data?.documents || [],
            documents_data: newDocumentsArray || [],
            errors: errorArray || [],
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleSubmit = () => {
    const { apiHeaderJSON, apiURL } = this.context;
    const headers = apiHeaderJSON;
  
      Swal.fire({
        title: "Are you sure?",
        text: `You want to add documents!`,
        icon: "warning",
        showCancelButton: true,
        // confirmButtonColor: "#3085d6",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Add!",
        allowOutsideClick: false,
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.setState({ loadingPost: true });
        const data = {
          employee_id: this.state.employee_id,
          selectedDocumentRows: this.state.selectedDocumentRows, 
        };
        console.log("data", data);
        axios
        .post(`${apiURL}Employees/AddOtherDocumentsToEmployee`, data, {headers})
        .then((response) => {
          const data = response.data;
          if (response.data.success === true) {
            console.log("AddOtherDocumentsToEmployee =>", data);
            this.GetList();
            this.GetDocumentList();
            this.setState({ selectedDocumentRows: [], documentModal: false });
          }
          this.setState({ loadingPost: false });
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        })
        .catch((error) => {
          this.setState({ loadingPost: false });
          Swal.fire({
            title: `<strong>${"Failed"}</strong>`,
            text: "Opps...! Something went wrong!",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          });
          console.error("Error uploading file:", error);
        });
      });
    };

  DownloadDocument = (employee_document_id, event) => {
    event.preventDefault();
  };

  validateForm = (idx)=>{
    const updatedDocumentsData = [...this.state.documents_data]; 

    const errors=[...this.state.errors];
    const file= this.state.documents_data[idx]?.document_file;
    // console.log(file);
    if(!file){
      errors[idx] = {
        ...errors[idx], 
        document_file: "Document is required!",
      };
      return errors;
    }

    if(file){
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf",];
      const maxFileSize = 2 * 1024 * 1024; // 2MB in bytes
      console.log(file.size);
      if (!allowedTypes.includes(file.type)) {
        errors[idx] = {
          ...errors[idx], 
          document_file: "Invalid file type. Allowed types: jpg, png, pdf.",
        };
        return errors;
      }
      else if (file.size >= maxFileSize) {
        errors[idx] = {
          ...errors[idx], 
          document_file: "File size must be less than 2MB.",
        };
        return errors;
      }
    }

    // if(!this.state.documents_data[idx]?.document_number){
    //   errors[idx] = {
    //     ...errors[idx], 
    //     document_number: "Document Number is required!",
    //   };
    //   return errors;
    // }

    return errors;

  }

  handleCheckboxChange = (employee_document_type_id) => {
    this.setState((prevState) => {
      const selectedDocumentRows = [...prevState.selectedDocumentRows];

      if (selectedDocumentRows.includes(employee_document_type_id)) {
        selectedDocumentRows.splice(
          selectedDocumentRows.indexOf(employee_document_type_id),1);
      } else {
        selectedDocumentRows.push(employee_document_type_id);
      }
      console.log("selectedDocumentRows", selectedDocumentRows);
      return { selectedDocumentRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedDocumentRows =
        prevState.selectedDocumentRows.length === prevState.docRows.length
          ? []
          : prevState.docRows.map((row) => row.employee_document_type_id);

      return { selectedDocumentRows };
    });
  };


  render() {
    const { rows, loadingList } = this.state;
    return loadingList? ( <MainPageLoader/> ) : (
      <div className="main-content">
        <div className="card">
            <div className="card-body">
                <div class="card-header d-flex justify-content-between align-items-center ">
                  <div class="">
                    <h5>Documents Details
                      <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                    </h5>
                    <p className="text-muted">Fill all information below</p>
                  </div>
                  <div>
                    <SubmitButton onClick={(e)=>{ this.setState({ documentModal: true });}}
                    buttonName={'Add Document'} icon={'ri-book-read-line'}
                    type='primary' iconSide='left' />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div style={{ "maxHeight": "57vh", "overflowY": "auto" }} className="col-sm-12">
                      <table className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed" style={{ width: '100%' }} aria-describedby="example_info">
                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                          <tr>
                            <th scope="col" className="text-start">File Name</th>
                            <th scope="col">Document Number</th>
                            {/* <th scope="col">Remark</th> */}
                            <th scope="col">Status</th>
                            <th scope="col">Upload</th>
                            <th scope="col">Verified</th>
                          </tr>
                        </thead>
                        {rows?.length === 0?
                          <tbody>
                              <tr>
                                  <td colSpan={9}>
                                      <NoRecords/>
                                  </td>
                              </tr>
                          </tbody>:
                          <tbody>
                          {rows.map((row,idx) => (
                              <tr key={row.employee_document_type_id}>
                                  <td>
                                  <div className="d-flex align-items-center">
                                  {row.employee_document_url && !this.state.documents_data[idx]?.document_file ? (
                                    <div className="avatar-sm cursorPointer"
                                    onClick={() => { this.setState({ doc_title: row?.employee_document_type_title, doc_url: row?.employee_document_url, viewDocument: true,});}}>
                                      <div style={{ color: "blue" }} className="avatar-title text-primary bg-info-subtle text-danger rounded fs-20" >
                                        <i className="ri-eye-fill text-primary" />
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="avatar-sm">
                                      <div className="avatar-title bg-danger-subtle text-danger rounded fs-20">
                                        <i className="ri-file-3-fill" />
                                      </div>
                                    </div>
                                  )}
                                    <div className="ms-3 flex-grow-1">
                                        <div className="fs-15 mb-0 text-start">
                                        <div className="text-truncate mb-0 fw-semibold"
                                        style={{ maxWidth: "14rem",  overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", color:"rgb(68 132 255)"}} >
                                            {row.employee_document_type_title}
                                        </div>
                                        <div style={{ minWidth: "11rem",  overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>
                                          <div className=" d-flex align-items-center gap-1" >
                                            <h6 className="text-truncate mb-0"
                                            style={{ maxWidth: "11rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",}}> {this.state.documents_data[idx]?.document_file?.name ?this.state.documents_data[idx]?.document_file?.name : 
                                            row.employee_document_url? 
                                            row.employee_document_url?.split("/")[row.employee_document_url?.split("/")?.length-1] :"--"}</h6>
                                            {this.state.documents_data[idx]?.document_file?.name && (
                                            <button type="button" className="btn-close" aria-label="Close" onClick={()=> this.removeFile(idx)}></button>)}
                                          </div>
                                            {/* <small className="text-muted">
                                            {row.document_remark ||
                                                "No Remark !!"}
                                            </small> */}
                                        </div>
                                        </div>
                                    </div>
                                  </div>
                                  {this.state.errors[idx]?.document_file && ( <small className="text-danger" >{this.state.errors[idx]?.document_file} </small> )}
                              </td>
                              <td>
                              <div className="d-flex align-items-center">
                                <input onChange={(e)=> this.handleRowInputChange(e,idx,row)}
                                id="document_number" name="document_number"
                                type="text" label="document_number"
                                className=" py-1 px-2" placeholder="Enter ID Number"
                                disabled={!this.state.documents_data[idx]?.document_file}
                                value={this.state.documents_data[idx]?.employee_document_uid || row?.employee_document_uid}
                                />
                              </div>
                              </td>
                              {/* <td>
                                  <button
                                  type="button"
                                  className={`${row.document_status_label === "Verified" || row.document_status_label === "Pending" ? "disabled" : ""} btn btn-light btn-sm btn-label waves-effect right waves-light`}
                                  onClick={() =>
                                      this.RemarkDocument(
                                      this.state.employee_id,
                                      row
                                      )
                                  }
                                  >
                                  <i className="bx bx-info-circle label-icon align-middle fs-16 ms-2" />
                                  Remark
                                  </button>
                              </td> */}
                              <td>
                                  <span className={`badge bg-${row.document_status_color} w-100 px-3 py-2`}>
                                    {row.document_status_label}
                                  </span>
                              </td>
                              <td>
                              {!this.state.documents_data[idx]?.document_file  ?
                              <>
                                  <input
                                  type="file"
                                  id={`fileInput-${row?.employee_document_type_id}`}
                                  style={{ display: "none" }}
                                  disabled={this.state.loadingUpload}
                                  onChange={(e) =>{
                                    // console.log("document_file",this.state.documents_data[idx]?.document_file);
                                  // if(this.state.documents_data[idx]?.document_file){
                                  //   this.handleFileUpload(e, row,idx)
                                  //   console.log("handleFileUpload",this.state.documents_data[idx]?.document_file);
                                  // }
                                  // else{
                                      this.handleFileChange(e,idx)     
                                  // }
                                }
                                  }
                                  accept="image/png, image/jpg, image/jpeg, .pdf"
                                  />
                                  {row.document_status_label === "Uploaded" ? (
                                  <>
                                      <label
                                      htmlFor={`fileInput-${row.employee_document_type_id}`}
                                      className={`btn noWrap w-100 btn-secondary btn-sm btn-label waves-effect waves-light py-2 mb-0`}
                                      >
                                      <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                      Change
                                      </label>
                                  </>
                                  ) : (
                                  <>
                                  
                                      <label
                                      htmlFor={`fileInput-${row?.employee_document_type_id}`}
                                    
                                      className={`${row.document_status_label === "Verified" ? "disabled" : ""} btn noWrap w-100 btn-${"success"} btn-sm btn-label waves-effect waves-light py-2 mb-0`}
                                      >
                                        {this.state.loadingUpload == row?.employee_document_type_id?
                                        <span class="spinner-border flex-shrink-0" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                        </span>:
                                        <i className={`ri-file-upload-line label-icon align-middle fs-16 me-2`} />
                                        }
                                        {"Choose File"}
                                      </label>

                                      
                                  </>
                                  )}
                                  </>:
                                  this.state.loadingUpload == row?.employee_document_type_id?
                                  <button className="btn w-100 btn-primary btn-load"
                                  >
                                  <span className="d-flex align-items-center">
                                      <span className="spinner-border flex-shrink-0" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                      </span>
                                      <span className="flex-grow-1 ms-2">
                                      Uploading...
                                      </span>
                                      </span>
                                  </button>:
                                  <button
                                  onClick={()=> {
                                    console.log("document_file",this.state.documents_data[idx]?.document_file,this.state.loadingUpload);
                                      this.handleFileUpload( row,idx);
                                    }
                                    }
                                  className={`${this.state.loadingUpload? "disabled" : ""} btn btn-secondary btn-label waves-effect waves-light`}
                              >
                                  <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                  Upload
                              </button>
                                  
                                    }
                              </td>
                              <td>
                            {/* <button
                              type="button"
                              className={`${row.document_status_label === "Pending" ? "disabled" : " "} btn btn-success btn-sm btn-label waves-effect right waves-light`}
                              onClick={() => this.VerifyDocument(row.employee_document_id)} >
                              <i className=" ri-check-double-line label-icon align-middle fs-16 ms-2" />
                              Verify
                            </button> */}

                              {row.document_status_label === "Verified" ? (
                                <>
                                  <button
                                    type="button"
                                    className={`${
                                      row.document_status_label === "Pending"
                                        ? "disabled"
                                        : " "
                                    } btn btn-secondary btn-label waves-effect waves-light`}
                                    onClick={() =>
                                      this.VerifyDocument(row, "3")
                                    }
                                  >
                                    <i className="ri-close-line label-icon align-middle fs-16" />
                                    Unverify
                                  </button>
                                </>
                                ) : (
                                <>
                                  <button
                                    type="button"
                                    className={`${
                                      row.document_status_label === "Pending"
                                        ? "disabled"
                                        : " "
                                    } btn btn-success btn-label waves-effect waves-light`}
                                    onClick={() =>
                                      this.VerifyDocument(row, "2")
                                    }
                                  >
                                    <i className=" ri-check-double-line label-icon align-middle fs-16" />
                                    Verify
                                  </button>
                                </>
                                )} 
                          </td>
                              </tr>
                          ))}
                          </tbody>
                        }
                      </table>
                    </div> 
                  </div>
                </div>
                {this.state.viewDocument && (
                    <div id="myModal" className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                      <div className="m-auto mt-3 w-modal">
                        <div className="modal-content">
                          <div className="modal-header pb-0">
                            <h5 className="modal-title" id="myModalLabel">Document</h5>
                            <button onClick={() => { this.setState({ viewDocument: false, doc_title: "", doc_url: "", }); }} className="btn-close" aria-label="Close"/>
                          </div>
                          <div className="modal-body pt-0">
                            <div className="row">
                              <div className="mb-4 m-auto p-1 rounded-2 grayBlurShadow">
                                <h3 className="text-center">{this.state.doc_title}</h3>
                                <div className="m-auto rounded-3 overflow-hidden" style={{ width: "100%", height: "600px", border: "1px solid #ccc",}}>
                                  {this.state.doc_url?.includes("pdf") ? (
                                    <iframe
                                      src={this.state.doc_url}
                                      title="PDF Viewer"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      frameBorder="0"
                                    >
                                      This browser does not support embedded
                                      files.
                                    </iframe>
                                  ) : (
                                    <img src={this.state.doc_url} style={{ width: "100%" }}alt="document_image"/>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button onClick={() => { this.setState({ viewDocument: false, doc_title: "", doc_url: "", }); }} className="btn btn-light">
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {this.state.documentModal && (
                    <div id="myModal" className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                      <div className="m-auto mt-3 w-modal">
                        <div className="modal-content">
                          <div className="modal-header pb-0">
                            <h5 className="modal-title" id="myModalLabel">Document</h5>
                            <button onClick={() => { this.setState({ documentModal: false, doc_title: "", doc_url: "", }); }} className="btn-close" aria-label="Close"/>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                <table className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed" style={{ width: '100%' }} aria-describedby="example_info">
                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                    <tr>
                                      {this.state.docRows?.length > 0 &&
                                      (<th width={`10%`}>
                                        <div className="d-flex align-items-center gap-2">
                                          <button type="button" className="btn p-0">
                                            <input type="checkbox" className="form-check-input "
                                              checked={ this.state.selectedDocumentRows.length === this.state.docRows.length}
                                              onChange={this.handleSelectAll}
                                            />
                                          </button>                                          
                                          <p className=" mb-0">Select</p>
                                        </div>
                                      </th>)}
                                      <th width={`10%`}>Sr.No.</th>
                                      <th width={`80%`}>Document Title</th>
                                    </tr>
                                  </thead>
                                  {this.state.docRows?.length === 0 ?
                                  <tbody>
                                    <tr>
                                      <td colSpan={2}>
                                          <NoRecords/>
                                      </td>
                                    </tr>
                                  </tbody> :
                                  <tbody>
                                    {this.state.docRows.map(
                                      (row, idx) => {
                                        return (
                                          <tr key={ row?.employee_document_type_id}>
                                            <td>
                                              <div className="d-flex justify-content-center align-items-center">
                                                <input type="checkbox" className="form-check-input"
                                                  checked={this.state.selectedDocumentRows.includes(row?.employee_document_type_id)}
                                                  onChange={() => this.handleCheckboxChange(row.employee_document_type_id) }
                                                />
                                              </div>
                                            </td>
                                            <td>{idx + 1}</td>
                                            <td>{row?.employee_document_type_title}</td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  }
                                </table>
                              </div>
                              <div className=" d-flex justify-content-end align-items-center">
                                <SubmitButton onClick={this.handleSubmit} loading={this.state.loadingPost} loadingMessage='Loading' 
                                disabled={this.state.selectedDocumentRows?.length===0}
                                buttonName={"Add"} icon={'ri-save-line'} 
                                type='primary' iconSide='left' />
                              </div>
                            </div>
                          </div>  
                        </div>
                      </div>
                    </div>
                  )}
            </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DocumentDetails);


